import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { CircularProgress, Grid, Typography } from "@mui/material";

export default function JobCostSummaryTable({
  title,
  items,
  hiddenColumns = [],
  loading,
}) {
  const [data, setData] = useState([]);

  const columns = [
    { name: "BUILDER", label: "Builder" },
    { name: "JOB", label: "Project" },
    { name: "LOT", label: "Job" },
    { name: "CONTRACT", label: "Contract" },
    {
      name: "PERCENT_COMPLETE",
      label: "Percent Completed",
      options: {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;

          return `${value}%`;
        },
      },
    },
    { name: "GROSS_PROFIT_EST", label: "Gross Profit Estimation" },
    { name: "TOTAL_ACT_COST", label: "Actual Total Cost" },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
  };

  useEffect(() => {
    if (items !== null) setData([...items]);
  }, [items]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <MUIDataTable
          title={
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5">{title}</Typography>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress size="1rem" />
                </Grid>
              )}
            </Grid>
          }
          data={data}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
}
